import React, { useEffect, useRef } from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { BiTrendingUp, BiCode, BiLineChart, BiTask, BiBook, BiBuildings } from 'react-icons/bi';

const SERVICES = [
    {
        icon: <BiTrendingUp />,
        title: 'Business Strategy',
        desc: 'Data-driven market analysis, competitive positioning, and growth roadmaps tailored to your unique business context.',
    },
    {
        icon: <BiCode />,
        title: 'Technology Solutions',
        desc: 'From custom software development to digital transformation — we modernise your operations end-to-end.',
    },
    {
        icon: <BiLineChart />,
        title: 'Financial Advisory',
        desc: 'Investment analysis, risk management, fundraising strategy, and financial modelling to secure your future.',
    },
    {
        icon: <BiTask />,
        title: 'Project Management',
        desc: 'Certified PMs delivering projects on time, within scope, and on budget across complex multi-stakeholder environments.',
    },
    {
        icon: <BiBook />,
        title: 'Training & Capacity',
        desc: 'Bespoke training programmes and leadership development that build lasting organisational capability.',
    },
    {
        icon: <BiBuildings />,
        title: 'Government Advisory',
        desc: 'Policy development, public-private partnerships, and institutional strengthening for government and NGO clients.',
    },
];

function Services() {
    const sectionRef = useRef(null);

    useEffect(() => {
        const el = sectionRef.current;
        if (!el) return;
        const targets = el.querySelectorAll('.fade-up');
        const observer = new IntersectionObserver(
            entries => entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target); } }),
            { threshold: 0.08 }
        );
        targets.forEach(t => observer.observe(t));
        return () => observer.disconnect();
    }, []);

    return (
        <section id="services" className="section section-alt" ref={sectionRef}>
            <div className="services-header text-center fade-up">
                <p className="section-label">What We Do</p>
                <h2 className="section-title">
                    Comprehensive <span className="gradient-text">Services</span>
                </h2>
                <p className="section-subtitle">
                    Six core practice areas — all designed to accelerate growth and build
                    sustainable competitive advantage.
                </p>
            </div>

            <div className="services-grid">
                {SERVICES.map((svc, i) => (
                    <div
                        key={i}
                        className={`service-card fade-up delay-${(i % 3) + 1}`}
                    >
                        <div className="service-icon-wrap">{svc.icon}</div>
                        <h3>{svc.title}</h3>
                        <p>{svc.desc}</p>
                        <span
                            className="service-link"
                            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
                        >
                            Learn More <FaArrowRight style={{ fontSize: '0.75rem' }} />
                        </span>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default Services;

